/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-pick-up-40e4efe6--sprite",
  "use": "car-pick-up-40e4efe6--sprite-usage",
  "viewBox": "0 0 49 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 49 21\" id=\"car-pick-up-40e4efe6--sprite\"><path d=\"M36 8h7a5 5 0 015 5v2a1 1 0 01-1 1h-5m-6-8l-7.717-6.753A1 1 0 0027.624 1H24.5a1 1 0 00-1 1v6M36 8H23.5M42 16a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H14m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H2a1 1 0 01-1-1V9a1 1 0 011-1h21.5\" stroke=\"#000\" stroke-width=\"2\" /><path d=\"M32 14l4-6H23.5v6H32zM.5 10H3v2H1m47-1h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
